import React from 'react';
import styles from './styles.module.css';

const OurStory = () => {
  return <div className={styles.headingStyles}>coming soon our Story</div>;
};

export default OurStory;
